var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.data.item.vendor_mappings || []),function(company){return _c('div',[_c('b-link',{attrs:{"to":{name:'admin_vendor_profile', params:{vendor_id:company.id}},"target":"_blank"}},[_vm._v(" "+_vm._s(company.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }